import CrudManager from '@/components/admin/CrudManager';

const fields = [
    { key: 'title', label: 'Title', type: 'text' },
    { key: 'summary', label: 'Summary', type: 'textarea', rows: 2 },
    { key: 'description', label: 'Full description', type: 'rich-text' },
    { key: 'category', label: 'Category', type: 'text' },
    { key: 'budget', label: 'Budget', type: 'text', placeholder: 'e.g. \u20b95.5 Crore' },
    { key: 'timeline', label: 'Timeline', type: 'text', placeholder: 'e.g. 36 months' },
    { key: 'location', label: 'Location', type: 'text' },
    { key: 'beneficiaries', label: 'Beneficiaries', type: 'text' },
    { key: 'image_url', label: 'Image', type: 'upload-image', prefix: 'proposal-projects' },
    { key: 'outcomes_targeted', label: 'Outcomes targeted', type: 'array', hint: 'Comma-separated list' },
    { key: 'csr_alignment', label: 'CSR alignment tags', type: 'array', hint: 'Comma-separated tags' },
    { key: 'order', label: 'Order', type: 'number' },
];

const columns = [
    { key: 'title', label: 'Title', primary: true },
    { key: 'category', label: 'Category' },
    { key: 'budget', label: 'Budget' },
    { key: 'timeline', label: 'Timeline' },
];

const defaultItem = {
    title: '',
    summary: '',
    description: '',
    category: 'General',
    budget: '',
    timeline: '',
    location: '',
    beneficiaries: '',
    image_url: '',
    outcomes_targeted: [],
    csr_alignment: [],
    order: 99,
};

export default function AdminProposalProjectsPage() {
    return (
        <CrudManager
            resource="proposal-projects"
            title="Proposal Projects"
            description="Ready-to-fund projects for CSR partners."
            fields={fields}
            columns={columns}
            defaultItem={defaultItem}
            searchKeys={['title', 'category']}
        />
    );
}
